import { ActionBase } from '../../../core/store/action/ActionBase';
import { ListMetadataModel } from '../../models/ListMetadataModel';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const GET_ENTITY_LISTMETADATA_SUCCESS = `[${ModuleConfiguration.moduleName}] Get Entity List Metadata Success`;

export class GetEntityListMetadataSuccessAction implements ActionBase {
    readonly identifier = new Date().getTime().toString();
    readonly type = GET_ENTITY_LISTMETADATA_SUCCESS;
    constructor(public payload: { entityKey: string, scope?: string, metadata: ListMetadataModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/GetEntityListMetadataSuccessAction.ts